import './general.scss'
import '../scss/theme.scss'
import './blocks/tag-headline.scss'
import './blocks/theme-header.scss'
import './blocks/theme-footer.scss'
import './blocks/theme-footer-frontend'
import './blocks/hero-image.scss'
import './blocks/hero-image-frontend'
import './blocks/theme-header-frontend'
import checkTagHeadlineSpaces from "./blocks/tag-headline-frontend";

const checkTagHeadlineLists = () => {
    Array.from(document.getElementsByClassName('wp-block-werbebucher-tag-headline')).forEach(list => {
        const listId = list.getAttribute('data-id')
        checkTagHeadlineSpaces(listId)
    })
}

window.addEventListener('load', () => {
    checkTagHeadlineLists()

})

window.addEventListener('resize', checkTagHeadlineLists)
